import { isolerLtr } from './bidi';

const CURRENCY_SYMBOLS = {
  EUR: '€',
  ILS: '₪',
  USD: '$',
  GBP: '£',
};

export const getPreferredCurrency = () => {
  // Devise portée par le fournisseur (cf. jalon 4-b) ; fallback défensif quand
  // aucun code n'est passé à formatCurrency/getCurrencySymbol.
  return 'EUR';
};

export const getCurrencySymbol = (currency) => {
  const code = currency || getPreferredCurrency();
  return CURRENCY_SYMBOLS[code] || code;
};

/**
 * 🔴 LE RÉSULTAT EST ISOLÉ EN GAUCHE-DROITE, ET C'EST UN CORRECTIF DE DONNÉE,
 * PAS DE MISE EN FORME. Sous un paragraphe RTL, `12 345 678,90 €` s'affichait
 * `€ 678,90 345 12` : **les groupes de milliers sortaient en ordre INVERSE**,
 * parce que l'espace qui les sépare (un U+0020, ligne `grouped`) est un
 * caractère NEUTRE qui se résout dans la direction du paragraphe. *Un
 * séparateur de milliers invisible dans une langue est un opérateur de
 * réordonnancement dans une autre.*
 *
 * ⚠️ ET SOUS MILLE, LE DÉFAUT CHANGEAIT DE NATURE PLUTÔT QUE DE DISPARAÎTRE :
 * `999,00 €` n'a qu'un groupe, donc les CHIFFRES restaient dans l'ordre — mais
 * le SYMBOLE passait de l'autre côté. **Mal placé sous mille, FAUX au-dessus.**
 * *Seule la gravité dépendait du montant*, et c'est ce qu'un jeu d'essai
 * modeste ne montre jamais.
 *
 * ⚠️ LA SIGNATURE NE CHANGE PAS — elle rend toujours une CHAÎNE. C'est ce qui
 * laisse intacts les TROIS sites qui l'interpolent dans un gabarit et les
 * TRENTE-HUIT qui la rendent comme enfant JSX. Voir `utils/bidi.js` pour les
 * quatre voies mesurées, et pour celle qui a été infirmée.
 */
export const formatCurrency = (value, currency) => {
  const code = currency || getPreferredCurrency();
  const symbol = getCurrencySymbol(code);
  const num = Number(value) || 0;
  // Format à la française, identique au PDF (pdf_service.format_amount) :
  // séparateur de milliers = espace, décimale = virgule, symbole après un espace insécable.
  const [intPart, decPart] = num.toFixed(2).split('.');
  const grouped = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
  return isolerLtr(`${grouped},${decPart} ${symbol}`);
};


